
import React from "react";
import Submit from "./Submit";




const EditFormPage = () => {
  return (
    <div>
    <Submit/>
    </div>


  );
};

export default EditFormPage;